export default __webpack_public_path__ + "static/media/flying-email.f01218e2.gif";